import * as React from "react";
import {
  Box,
  Typography,
  TextField,
  InputLabel,
  Button,
  Stack,
  Toolbar,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation } from "react-router-dom";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
import {
  getFormSubmissionById,
  setCheckedFormById,
  setFormSubmissionChangeAnswer,
} from "../store/formInputesSubmission";
import {
  uploadFile,
  clearUpdateFileId,
  loadFileById,
  uploadFileTemp,
} from "../store/uploadFile";
import {
  submitFormSubmission,
  submitFormSubmissionOverride,
} from "../store/formSubmission";
import { useDispatch, useSelector } from "react-redux";
import ContainerDashboard from "../components/UI/ContainerDashboard";
import BottomToolbar from "../components/UI/BottomToolbar";
import DialogDelete from "../components/UI/DialogDelete";
import LogTable from "../components/FormatePlotesuara/LogTable";
import DialogComment from "../components/UI/DialogComment";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { getDateFormat } from "../components/helper/CustomLabel";
import TextFieldDateFilter from "../components/UI/TextFieldDateFilter";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { id, sq } from "date-fns/locale";
import InputUploadFile from "../components/UI/FormGridInputetComponents/InputUploadFile";
import InputFormula from "../components/UI/FormGridInputetComponents/InputFormula";
import InputSelect from "../components/UI/FormGridInputetComponents/InputSelect";
import formulaExtractStrings from "../utils/formulaExtractStrings";
import ButtonToolbar from "../components/UI/FormGridInputetComponents/ButtonToolbar";

const FormGridInputet = () => {
  const initialAnswers = [];

  // User check
  const user = useSelector((state) => state.auth.user);
  const isAdministrator = user?.role === "ROLE_EXECUTIVE" ? true : false;
  const isGlobalEditor = user?.isGlobalEditor ? user?.isGlobalEditor : false;

  const dispatch = useDispatch();

  // location navigation state
  const navigate = useNavigate();
  const location = useLocation();
  const stateFormInputId = location.state.stateFormInputId;
  const stateForm = location.state.stateForm;
  const nameForm = location.state.nameForm;
  const analystCheck = location.state?.analystCheck;
  const status = location.state?.status;
  const oshma = location.state?.oshma;
  const formSubmissionState = location.state?.formSubmissionState;
  const variableSubmission = location.state?.variableSubmission;

  const { formInputesSubmission, previousSubmissions, commentSubmission } =
    useSelector((state) => state.formInputesSubmission);
  const { uplaodFileId } = useSelector((state) => state.uplaodFile);

  // useStates
  const [errorValues, setErrorValues] = React.useState([]);
  const [stateComment, setStateComment] = React.useState("");
  const [stateFileId, setStateFileId] = React.useState("");
  const [stateCommentSend, setStateCommentSend] = React.useState("");
  const [dataSendWithComment, setDataSendWithComment] = React.useState({});
  const [dataSendWithApprove, setDataSendWithApprove] = React.useState({});
  const [errorDataCommnet, setErrorDataComment] = React.useState(false);
  const [stateDialogWarning, setStateDialogWarning] = React.useState(false);
  const [stateDialogComment, setStateDialogComment] = React.useState(false);
  const [stateDialogApprove, setStateDialogApprove] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [checked, setChecked] = React.useState(false);
  const [stateDialogExtraSubmission, setStateDialogExtraSubmission] =
    React.useState(false);
  const [finalDataSend, setFinalDataSend] = React.useState(false);

  // Handler functions
  const changeHandlerFiles = (event) => {
    const f = event.target.files[0];
    const formData = new FormData();
    formData.append("file", f);
    dispatch(uploadFile({ fileData: formData }));
    setFiles(event.target.files[0]);
  }; // Upload file

  const changeHandlerInputFiles = (event, item) => {
    const f = event.target.files[0];

    const formData = new FormData();
    formData.append("file", f);

    dispatch(
      uploadFileTemp({
        fileData: formData,
        stateFormInputesSubmission: formInputesSubmission,
        itemId: item?.id,
      })
    );
  };

  const onDeleteInputFiles = (event, item) => {
    dispatch(
      setFormSubmissionChangeAnswer({
        state: formInputesSubmission,
        id: item?.id,
        answerValue: "",
      })
    );
  }; // Delete upload file

  const onLoadInputFiles = (event, item) => {
    dispatch(loadFileById({ id: item?.answer?.answer }));
  };

  const onDeleteFile = () => {
    setFiles([]);
    dispatch(clearUpdateFileId());
  };

  // Logs Input Forms
  const [logsFormInputesSubmission, setLogsFormInputesSubmission] =
    React.useState([]);

  React.useEffect(() => {
    if (stateFormInputId) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
      setChecked(analystCheck);
    }
    if (isAdministrator) {
      setLogsFormInputesSubmission(formInputesSubmission);
    }
  }, [stateFormInputId, stateForm, nameForm]);

  React.useEffect(() => {
    if (stateFormInputId) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
    }
    if (isAdministrator) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
      setLogsFormInputesSubmission(formInputesSubmission);
    }
  }, []);

  React.useEffect(() => {
    if (isAdministrator) {
      setLogsFormInputesSubmission(formInputesSubmission);
    }
  }, [formInputesSubmission]);

  // End Logs Input Forms

  // Changes handle Functions
  const handleChange = (event) => {
    const { name, value, id } = event.target;

    for (var i = 0; i < errorValues.length; i++) {
      if (errorValues[i].id == id && value !== "") {
        errorValues.splice(i, 1);
        break;
      }
    }
    var valueTemp = parseInt(value);

    if (valueTemp < -1) {
      dispatch(
        setFormSubmissionChangeAnswer({
          state: formInputesSubmission,
          id: id,
          answerValue: -1,
        })
      );
    } else {
      dispatch(
        setFormSubmissionChangeAnswer({
          state: formInputesSubmission,
          id: id,
          answerValue: value,
        })
      );
    }
  }; // Input Chnage

  const saveForm = () => {
    formInputesSubmission.map((item) => {
      if (item.answer.answer === "" && item.type === "FORMULA") {
        initialAnswers.push({
          answer: getValueFromFormula(item?.properties?.formula)
            ? getValueFromFormula(item?.properties?.formula)
            : null,
          id: getValueFromFormula(item?.properties?.formula)
            ? item.answer.id
            : null,
        });
      } else if (item.answer != null) {
        initialAnswers.push({
          answer: item.answer ? item.answer.answer : null,
          id: item.answer ? item.answer.id : null,
        });
      } else {
      }
    });
    const dataSend = {};
    dataSend.id = stateFormInputId;
    dataSend.answers = initialAnswers;
    if (user?.role === "ROLE_EDITOR") {
      dataSend.status = "REVIEWED";
    } else {
      if (stateForm === "new") {
        dataSend.status = "DRAFT";
      } else {
        dataSend.status = "ACTIVE";
      }
    }
    dataSend.extraSubmission = false;
    dispatch(submitFormSubmission({ formSubmission: dataSend }));
    onBackNavigation();
  }; // Save form

  const sendForm = (e) => {
    var initialAnswersError = [];
    formInputesSubmission.map((item) => {
      if (item.answer.answer === "" && item.type === "FORMULA") {
        initialAnswers.push({
          answer: getValueFromFormula(item?.properties?.formula)
            ? getValueFromFormula(item?.properties?.formula)
            : null,
          id: getValueFromFormula(item?.properties?.formula)
            ? item.answer.id
            : null,
        });
      } else if (item.answer.answer !== "" || item.type !== "DOC") {
        initialAnswers.push({
          answer: item.answer ? item.answer.answer : null,
          id: item.answer ? item.answer.id : null,
        });
      } else {
        if (item.type !== "DOC") {
          initialAnswersError.push(item);
        }
      }
    });
    setErrorValues(initialAnswersError);

    if (initialAnswersError.length === 0) {
      const dataSend = {};
      dataSend.id = stateFormInputId;
      dataSend.answers = initialAnswers;

      if (isGlobalEditor && stateForm === "old") {
        dataSend.status = "REVIEWED";
        if (uplaodFileId !== "") {
          dataSend.file = uplaodFileId;
        }
        setDataSendWithComment(dataSend);
        handleCommentEdit(dataSend);
      } else {
        if (user?.role === "ROLE_EDITOR") {
          ///message: A jeni i sigurt qe doni te Aprovoni Formen?
          dataSend.status = "REVIEWED";
          dataSend.extraSubmission = false;
          setDataSendWithApprove(dataSend);
          handleApprove(dataSend);
        } else {
          dataSend.status = "SUBMITTED";
          if (variableSubmission) {
            setStateDialogExtraSubmission(true);
            setFinalDataSend(dataSend);
          } else {
            const finalDataSendTemp = {
              ...dataSend,
              extraSubmission: false,
            };
            dispatch(
              submitFormSubmission({ formSubmission: finalDataSendTemp })
            );
            navigate(-1);
          }
        }
      }
    } else {
      handleWarningMessage();
    }
  }; // End Send final form

  const handleSendDataSimple = () => {
    const finalDataSendTemp = { ...finalDataSend, extraSubmission: false };
    dispatch(submitFormSubmission({ formSubmission: finalDataSendTemp }));
    navigate(-1);
  };

  const handleSendDataExtra = () => {
    const finalDataSendTemp = { ...finalDataSend, extraSubmission: true };
    dispatch(submitFormSubmission({ formSubmission: finalDataSendTemp }));
    navigate(-1);
  };

  const handleWarningMessage = (e) => {
    setStateDialogWarning(true);
  };

  const handleBackForm = (e) => {
    setStateDialogWarning(false);
  };

  const handleApprove = (e) => {
    setStateDialogApprove(true);
  };

  const handleBackFormApprove = (e) => {
    setStateDialogApprove(false);
  };

  const handleCommentEdit = (e) => {
    setErrorDataComment(false);
    setStateDialogComment(true);
  };

  const handleBackFormComment = (e) => {
    setStateDialogComment(false);
  };

  // Data with Comment
  const handleSendDataComent = () => {
    const tempDataWithComent = dataSendWithComment;
    if (stateCommentSend == "" || stateCommentSend.trim().length === 0) {
      setErrorDataComment(true);
    } else {
      tempDataWithComent.comment = stateCommentSend;
      if (uplaodFileId !== "") {
        tempDataWithComent.file = uplaodFileId;
      }
      dispatch(
        submitFormSubmissionOverride({ formSubmission: tempDataWithComent })
      );
      navigate(-1);
    }
  };

  const handleSendDataApprove = () => {
    dispatch(submitFormSubmission({ formSubmission: dataSendWithApprove }));
    navigate(-1);
  };

  const changeComment = (e) => {
    const commentValue = e.target.value;
    if (commentValue !== "" || commentValue == " ") {
      setErrorDataComment(false);
      setStateCommentSend(e.target.value);
    } else {
    }
  };

  const handleSelectLog = (e) => {
    const getLog = e.answers;
    setStateComment(e?.comment);

    setStateFileId(e?.file);

    const newLogInputes = [];
    if (logsFormInputesSubmission == []) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
      setLogsFormInputesSubmission(formInputesSubmission);
    }
    getLog.forEach((itemLog) => {
      const newList = formInputesSubmission?.map((item) => {
        if (item?.answer?.id === itemLog?.id) {
          const updatedItem = {
            ...item,
            answer: {
              id: item?.answer?.id,
              answer: itemLog?.answer ? itemLog?.answer : "",
            },
          };
          newLogInputes.push(updatedItem);
          return updatedItem;
        }

        return item;
      });
    });
    setLogsFormInputesSubmission(newLogInputes);
  };

  const handleClickExportDoc = () => {
    if (stateFileId) {
      dispatch(loadFileById({ id: stateFileId }));
    }
  };

  const handleChangeCheck = (event) => {
    dispatch(setCheckedFormById({ id: stateFormInputId }));
    setChecked(event.target.checked);
  };

  const onBackNavigation = () => {
    navigate(-1);
  };

  const oshmaName = oshma?.name ? " - " + oshma?.name : "";

  const getValueFromFormula = (formula) => {
    const formulaList = formulaExtractStrings(formula, "{", "}");
    let sum = 0;
    formInputesSubmission.map((item) => {
      if (formulaList.includes(item?.key) && item?.answer?.answer !== "") {
        parseInt(item?.answer?.answer, 10);
        sum = sum + parseInt(item?.answer?.answer, 10);
      }
    });
    return sum;
  };

  return (
    <StartingPageContent
      pageName={
        stateForm === "old"
          ? isAdministrator
            ? "Logs - Forma e plotësuar"
            : "Forma e plotësuar"
          : "Plotësimi i formës"
      }
      back
      onClick={onBackNavigation}
    >
      <Stack spacing={2}>
        <Box sx={{ flexGrow: 1 }}>
          <ContainerDashboard
            header={
              <Box>
                <Typography variant="h5" sx={{ ml: 1 }}>
                  {nameForm?.charAt(0).toUpperCase() +
                    nameForm?.slice(1) +
                    oshmaName}
                </Typography>
              </Box>
            }
            analystCheck={checked}
            onChange={handleChangeCheck}
            status={status}
            id={stateFormInputId}
          >
            <>
              {commentSubmission !== "" && commentSubmission !== null && (
                <div>
                  Komenti i Editorit:{" "}
                  <span style={{ fontSize: "16px", color: "#ff5858" }}>
                    {commentSubmission}
                  </span>
                </div>
              )}
              {!isAdministrator ? (
                <Grid
                  container
                  // spacing={{ xs: 4, md: 4 }}
                  columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                >
                  <Grid
                    sx={{ height: "80px", color: "black", fontSize: "30px" }}
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                  >
                    <Grid item xs={3.2} sm={3.2} md={3.2} lg={3.2}>
                      <InputLabel sx={{ color: "black", fontSize: "22px" }}>
                        Indikator
                      </InputLabel>
                    </Grid>
                    <Grid
                      // sx={{ textAlign: "right" }}
                      item
                      xs={2.2}
                      sm={2.2}
                      md={2.2}
                      lg={2.2}
                    >
                      <InputLabel
                        sx={{
                          color: "black",
                          fontSize: "22px",
                        }}
                      >
                        Vlera
                      </InputLabel>
                    </Grid>
                    <Grid item xs={2.2} sm={2.2} md={2.2} lg={2.2}>
                      <InputLabel
                        sx={{
                          color: "black",
                          fontSize: "22px",
                          textAlign: "center",
                        }}
                      >
                        {previousSubmissions[0]}
                      </InputLabel>
                    </Grid>
                    <Grid item xs={2.2} sm={2.2} md={2.2} lg={2.2}>
                      <InputLabel
                        sx={{
                          color: "black",
                          fontSize: "22px",
                          textAlign: "center",
                        }}
                      >
                        {previousSubmissions[1]}
                      </InputLabel>
                    </Grid>
                    <Grid item xs={2.2} sm={2.2} md={2.2} lg={2.2}>
                      <InputLabel
                        sx={{
                          color: "black",
                          fontSize: "22px",
                          textAlign: "center",
                        }}
                      >
                        {previousSubmissions[2]}
                      </InputLabel>
                    </Grid>
                  </Grid>
                  {formInputesSubmission
                    ? formInputesSubmission.map((item) => (
                        <Grid
                          spacing={{ xs: 1, md: 1 }}
                          sx={{
                            alignItems: "center",
                            border: "1px solid #f5f8fc",
                            marginBottom: "2px",
                          }}
                          container
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                        >
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <InputLabel>{item.label}</InputLabel>
                            <FormHelperText> </FormHelperText>
                          </Grid>
                          <Grid
                            sx={{
                              alignItems: "center",
                              "&.MuiGrid-item": {
                                marginTop: "auto",
                              },

                              // textAlign: "right",
                            }}
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            key={item.key}
                          >
                            {item.type === "TEXT" || item.type === "NUMBER" ? (
                              <TextField
                                name={item.key}
                                autoComplete="off"
                                id={item.id}
                                variant="outlined"
                                defaultValue={
                                  item.defaultAnswer ? item.defaultAnswer : 0
                                }
                                value={item?.answer?.answer}
                                onChange={handleChange}
                                error={errorValues.find(
                                  (error) => error.key === item.key
                                )}
                                type={item.type} /// variable type
                                disabled={
                                  (stateForm === "old" && !isGlobalEditor) ||
                                  user?.role === "ROLE_EDITOR"
                                }
                                sx={{
                                  "& .MuiInputBase-root.MuiOutlinedInput-root":
                                    {
                                      backgroundColor: "#F6F8FC",
                                    },
                                }}
                                InputProps={{
                                  inputProps: { min: -1 },
                                  endAdornment: item.type === "NUMBER" && (
                                    <InputAdornment
                                      sx={{
                                        "&.MuiInputAdornment-root": {
                                          minWidth: "120px !important",
                                        },
                                      }}
                                      position="end"
                                    >
                                      {item.unit}
                                    </InputAdornment>
                                  ),
                                }}
                                helperText={
                                  errorValues.find(
                                    (error) => error.key === item.key
                                  )
                                    ? item.label + " është i detyruar"
                                    : " "
                                }
                              />
                            ) : item.type === "DATE" ? (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                locale={sq}
                              >
                                <DatePicker
                                  id={item?.id}
                                  name={item?.key}
                                  value={item?.answer?.answer}
                                  // views={["year", "month"]}
                                  // onChange={handleChange}
                                  disabled={
                                    (stateForm === "old" && !isGlobalEditor) ||
                                    user?.role === "ROLE_EDITOR"
                                  }
                                  onChange={(newValue) => {
                                    dispatch(
                                      setFormSubmissionChangeAnswer({
                                        state: formInputesSubmission,
                                        id: item?.id,
                                        answerValue: getDateFormat(newValue),
                                      })
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextFieldDateFilter
                                      onClick={handleChange}
                                      {...params}
                                      inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Date",
                                      }}
                                      maxWidth="170px"
                                      inputWidth="100px"
                                      height="48px"
                                    />
                                  )}
                                />
                                <FormHelperText> </FormHelperText>
                              </LocalizationProvider>
                            ) : item.type === "DOC" ? (
                              <InputUploadFile
                                onchangefile={(e) =>
                                  changeHandlerInputFiles(e, item)
                                }
                                filename={item?.answer?.answer}
                                onDelete={(e) => onDeleteInputFiles(e, item)}
                                onClick={(e) => onLoadInputFiles(e, item)}
                                deletable={
                                  formSubmissionState === "ACTIVE" ||
                                  formSubmissionState === "DRAFT"
                                }
                              />
                            ) : item.type === "SELECT" ? (
                              <InputSelect
                                id={item?.id}
                                value={item?.answer?.answer}
                                options={item?.properties?.options}
                                disabled={
                                  (stateForm === "old" && !isGlobalEditor) ||
                                  user?.role === "ROLE_EDITOR"
                                }
                                onChange={(e) => {
                                  dispatch(
                                    setFormSubmissionChangeAnswer({
                                      state: formInputesSubmission,
                                      id: item?.id,
                                      answerValue: e?.target?.value,
                                    })
                                  );
                                }}
                              />
                            ) : (
                              <InputFormula
                                id={item?.id}
                                name={item?.key}
                                value={getValueFromFormula(
                                  item?.properties?.formula
                                )}
                                formluatext={item?.properties?.formula}
                              />
                            )}
                          </Grid>
                          {/* Add previousAnswers grid */}
                        </Grid>
                      ))
                    : null}
                </Grid>
              ) : (
                <Box>
                  <Box
                    sx={{
                      width: "100%",
                      mb: 2,
                    }}
                  >
                    <LogTable
                      id={stateFormInputId}
                      title={
                        nameForm?.charAt(0)?.toUpperCase() + nameForm?.slice(1)
                      }
                      onSelectLog={handleSelectLog}
                    ></LogTable>
                  </Box>
                  {stateComment && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        paddingBottom: "15px",
                        paddingTop: "15px",
                      }}
                    >
                      <InfoIcon color="error" sx={{ mr: "5px" }}></InfoIcon>
                      <Typography color="error" sx={{ fontSize: "16px" }}>
                        {stateComment}
                      </Typography>
                    </Box>
                  )}
                  {stateFileId && (
                    <Button
                      sx={{
                        backgroundColor: "#7CB0FF",
                        height: "40px",
                        mb: "10px",
                        ":hover": { backgroundColor: "#7CB0FF" },
                      }}
                      variant="contained"
                      onClick={handleClickExportDoc}
                      startIcon={<FileDownloadIcon />}
                    >
                      Eksporto Dokumentin
                    </Button>
                  )}
                  <Box>
                    <Grid
                      container
                      spacing={{ xs: 4, md: 4 }}
                      columns={{ xs: 1, sm: 8, md: 8, lg: 12 }}
                    >
                      {logsFormInputesSubmission
                        ? logsFormInputesSubmission.map((item) => (
                            <Grid
                              sx={{
                                "&.MuiGrid-item": {
                                  marginTop: "auto",
                                },
                              }}
                              item
                              xs={2}
                              sm={4}
                              md={4}
                              key={item.key}
                            >
                              <Stack spacing={2}>
                                <InputLabel>{item.label}</InputLabel>
                                <TextField
                                  name={item.key}
                                  autoComplete="off"
                                  id={item.id}
                                  variant="outlined"
                                  value={item?.answer?.answer}
                                  type="text"
                                  disabled
                                  sx={{
                                    "& .MuiInputBase-root.MuiOutlinedInput-root":
                                      {
                                        backgroundColor: "#F6F8FC",
                                      },
                                  }}
                                  InputProps={{
                                    inputProps: { min: -1 },
                                    endAdornment: (
                                      <InputAdornment
                                        sx={{
                                          "&.MuiInputAdornment-root": {
                                            minWidth: "120px !important",
                                          },
                                        }}
                                        position="end"
                                      >
                                        {item.unit}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Stack>
                            </Grid>
                          ))
                        : null}
                    </Grid>
                  </Box>
                </Box>
              )}
            </>
          </ContainerDashboard>
        </Box>
      </Stack>
      <Toolbar></Toolbar>
      {stateForm === "old" || stateForm === "old" ? null : (
        <BottomToolbar>
          <ButtonToolbar
            variantStatus={user?.role === "ROLE_EDITOR" ? "approve" : "save"}
            onClick={user?.role === "ROLE_EDITOR" ? sendForm : saveForm}
          />
          {user?.role !== "ROLE_EDITOR" ? (
            <ButtonToolbar variantStatus="send" onClick={sendForm} />
          ) : null}
        </BottomToolbar>
      )}
      {isGlobalEditor && stateForm === "old" ? (
        <BottomToolbar>
          <ButtonToolbar variantStatus="approve" onClick={sendForm} />
        </BottomToolbar>
      ) : null}
      <DialogDelete
        open={stateDialogWarning}
        agreedelete={handleBackForm}
        warning
        description={
          "Keni vlera të pa plotësuara, ju lutem plotësoni të gjitha fushat e kërkuara!"
        }
      />
      <DialogDelete
        open={stateDialogExtraSubmission}
        description={"A doni të rikrijoni një form tjetër?"}
        disagreedelete={handleSendDataSimple}
        agreedelete={handleSendDataExtra}
      />
      <DialogComment
        open={stateDialogComment}
        //comment={commen}
        required
        error={errorDataCommnet ? errorDataCommnet : undefined}
        //error={errorDataCommnet?error={condition ? value : undefined}}
        inputref={stateComment}
        onchangecomment={changeComment}
        disagreeComment={handleBackFormComment}
        submitComment={handleSendDataComent}
        description={"Lini komentin tuaj për ndryshimet përkatëse"}
        // files={files}
        filename={files?.name}
        filevalue={files}
        onDelete={onDeleteFile}
        onchangefile={changeHandlerFiles}
      />
      <DialogDelete
        open={stateDialogApprove}
        description={"Jeni të sigurt që doni të Aprovoni këtë formë?"}
        disagreedelete={handleBackFormApprove}
        agreedelete={handleSendDataApprove}
      />
    </StartingPageContent>
  );
};

export default FormGridInputet;
